import React, { useEffect, useRef, useState } from 'react';
import { useSnackbars } from '../../hooks/snackbar.hook';
import EnterpriseInfosUi from '../../components/user-interfaces/contact-us/enterprise-infos-ui';
import PersonalSpaceUi from '../../components/user-interfaces/contact-us/personal-space.ui';
import { Grid } from '@mui/material';
import './contact-us.page.scss';
import { getInterlocutorsTypes } from '../../services/references.service';
import { InterlocutorsReferenceDto } from '../../services/dtos/interlocutors-reference.dto';
import { AxiosError } from 'axios';
import ContactUsForm from '../../components/forms/contact-us/contact-us.form';
import useRecaptcha from '../../hooks/google-recaptcha.hook';
import { ContactUsDto } from '../../services/dtos/contact-us.dto';
import { useNavigate } from 'react-router-dom';
import { contactUs } from '../../services/contact-us.service';
import { showAxiosMessageError } from '../../services/error-message.service';

/**
 * Composant de la page de contact
 */
export default function ContactUsPage() {
    //Navigate
    const navigate = useNavigate();
    //UseStae utiles pour le formulaire et la vue
    const [validate, setValidate] = React.useState(false);
    const [isMoral, setIsMoral] = React.useState(false);

    // Références
    const [interlocutors, setInterlocutors] = useState<InterlocutorsReferenceDto[]>([]);

    // nackBar pour les messages
    const showMessage = useSnackbars();
    // Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);

    //Recaptcha
    const { getRecaptchaToken } = useRecaptcha('contactez_nous');

    /**
     * Permet de gérer sur quelle vue de tab est affichée.
     */
    const handleSubmitForm = (form: ContactUsDto) => {
        // Empêche de pouvoir submit pendant le traitement
        setValidate(true);
        //Récupération du recaptcha
        getRecaptchaToken()
            .then(token => {
                //On met à jour le recaptcha
                let contactUsDto: ContactUsDto = {
                    ...form,
                    tel: '0' + form.tel,
                    captcha: token,
                };
                contactUs(contactUsDto)
                    .then(() => {
                        showMessage.successAlert('Votre demande de contact a bien été prise en compte.');
                        navigate('/');
                    })
                    .catch((error: Error | AxiosError) => {
                        showAxiosMessageError(error, showMessage);
                    })
                    .finally(() => {
                        setValidate(false);
                    });
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            });
    };

    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;

        //Appel types d'interlocuteurs
        getInterlocutorsTypes()
            .then(result => {
                const data: InterlocutorsReferenceDto[] =
                    result &&
                    result.map(e => {
                        return {
                            id: e.id,
                            label: e.nom,
                            moralPerson: e.personneMorale,
                        };
                    });
                setInterlocutors(data);
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Changement de la variable isMoral au choix de l'interlocuteur (a une influence sur les champs affichés dans le formulaire
     * @param e déclencheur de l'évènement
     */
    const handleChangeInterlocutor = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        e.preventDefault();
        const selectedInterlocutor = interlocutors.find(interlocutor => interlocutor.id === e?.target?.value);
        setIsMoral(selectedInterlocutor?.moralPerson === undefined ? false : selectedInterlocutor.moralPerson);
    };

    return (
        //Affichage des trois éléments de la page
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <PersonalSpaceUi />
            </Grid>
            <Grid item xs={12} md={6}>
                <EnterpriseInfosUi />
            </Grid>
            <Grid item xs={12}>
                <hr className="hr-form-contact-us" />
            </Grid>
            <Grid item xs={12}>
                <ContactUsForm
                    handlerSubmit={handleSubmitForm}
                    validate={validate}
                    isMoral={isMoral}
                    handleChangeInterlocutor={handleChangeInterlocutor}
                    interlocutors={interlocutors}
                ></ContactUsForm>
            </Grid>
        </Grid>
    );
}
